module.exports = __webpack_public_path__ + "img/Max.e46ecddf.jpg";